import { signal } from '@angular/core';

/**
 * Error al cargar la API de Google Maps (sin red, script bloqueado o key/referrer no autorizados).
 * Las pantallas con mapa lo muestran con <app-map-error>.
 */
export const mapsLoadError = signal(false);

/**
 * @name loadGoogleMapsApi
 * @desc Carga la API de Google Maps con la key del ambiente (environment.googleMaps.apiKey).
 * Reemplaza al <script> fijo de index.html: la misma URL (loading=async), pero con la key de
 * desarrollo o de produccion segun la build. Las librerias adicionales (marker, routes) se cargan
 * bajo demanda con google.maps.importLibrary().
 */
export function loadGoogleMapsApi(apiKey: string): void {
    if (document.querySelector('script[data-google-maps-api]')) {
        return;
    }
    // Google llama a esta funcion global cuando la key o el dominio (referrer) no estan autorizados
    (window as unknown as { gm_authFailure: () => void }).gm_authFailure = () => mapsLoadError.set(true);

    const params = new URLSearchParams({ key: apiKey, loading: 'async', libraries: 'maps' });
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://maps.googleapis.com/maps/api/js?${params}`;
    script.dataset['googleMapsApi'] = '';
    script.onerror = () => mapsLoadError.set(true);
    document.head.appendChild(script);
}
